namespace Seac.Components {
	class Header {
		private _impresaLocalStorageKey		: string = 'ImpresaData';
		private _ufficioLocalStorageKey		: string = 'UfficioData';
		private _impresaIdLocalStorageKey	: string = 'ImpresaId';

		public init(): void {
			let impresaString	: string = Cookies.get(Seac.Commons.ServerConstants.Constants.COOKIE_IMPRESA);
			let ufficioString	: string = Cookies.get(Seac.Commons.ServerConstants.Constants.COOKIE_UFFICIO);
			let impresaId		: string = Cookies.get(Seac.Commons.ServerConstants.Constants.COOKIE_IMPRESA_ID);

			// Se sono presenti cookie per impresa o ufficio li salvo nel local storage e cancello il cookie
			if (impresaString) {
				localStorage.setItem(this._impresaLocalStorageKey, impresaString);
				Cookies.remove(Seac.Commons.ServerConstants.Constants.COOKIE_IMPRESA);
				localStorage.setItem(this._impresaIdLocalStorageKey, impresaId);
			}
			if (ufficioString) {
				localStorage.setItem(this._ufficioLocalStorageKey, ufficioString);
				Cookies.remove(Seac.Commons.ServerConstants.Constants.COOKIE_UFFICIO);
			}

			const localStorageImpresaId: string = localStorage.getItem(this._impresaIdLocalStorageKey);
			// Se l'Id dell'impresa del cookie è diverso dal valore presente in localStorage svuoto i valori salvati
			if (localStorageImpresaId != impresaId) {
				localStorage.removeItem(this._impresaLocalStorageKey);
				localStorage.removeItem(this._ufficioLocalStorageKey);
			}

			impresaString = localStorage.getItem(this._impresaLocalStorageKey);
			ufficioString = localStorage.getItem(this._ufficioLocalStorageKey);

			if (impresaString) {
				const impresa: Seac.Models.ImpresaCookieDto = JSON.parse(impresaString);
				// TODO: implementarli in maniera più decorosa
				// Compongo la stringa con i dati nascosti di degub
				const impresaDatiNascosti: string = `<span class="text-white"> - ${impresaId}</span>`;

				$('.dati-aggiuntivi-row.impresa-header-row').html(`${impresa.Denominazione}${impresaDatiNascosti}`);
				let datiAggiuntivi: string = `${impresa.CodiceFiscale ?? impresa.PartitaIVA} - ${impresa.Servizio}`;
				if (impresa.ChiaveImpresa) {
					datiAggiuntivi += ` - ${impresa.ChiaveImpresa}`;
				}
				$('.dati-aggiuntivi-row.impresa-data-row').text(datiAggiuntivi);
			}

			if (ufficioString) {
				const ufficio: Seac.Models.UfficioCookieDto = JSON.parse(ufficioString);
				$('.dati-aggiuntivi-row.ufficio-row').text(`${ufficio.Codice} - ${ufficio.Descrizione}`);
			}else {
				$('.dati-aggiuntivi-row.impresa-header-row').addClass('empty-ufficio');
			}
		}
	}

	export const header: Header = new Header();
	jQuery(document).ready(() => {
		header.init();
	})
}
